/**
 * PlayerSoundToggle
 *
 * Mute/unmute button in the header. Audio auto-initializes on first
 * user interaction — this just controls the player's personal mute.
 */

import { useAudioStore } from '../stores/audioStore';
import { Icon } from './Icon';

const GOLD = '#d4af37';

export function PlayerSoundToggle() {
  const isMuted = useAudioStore((s) => s.isMuted);
  const setMuted = useAudioStore((s) => s.setMuted);
  const currentMood = useAudioStore((s) => s.currentMood);
  const activeLayers = useAudioStore((s) => s.activeLayers);

  const hasAudio = currentMood || activeLayers.length > 0;
  const active = !isMuted && hasAudio;
  const iconColor = isMuted ? 'rgba(192,192,192,0.35)' : active ? GOLD : 'rgba(192,192,192,0.5)';

  return (
    <button
      onClick={() => setMuted(!isMuted)}
      title={isMuted ? 'Unmute audio' : 'Mute audio'}
      style={{
        width: 28,
        height: 28,
        padding: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'transparent',
        border: `1px solid ${active ? `${GOLD}40` : 'rgba(192,192,192,0.2)'}`,
        borderRadius: '50%',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        boxShadow: active ? `0 0 8px ${GOLD}30` : 'none',
        opacity: isMuted ? 0.5 : 1,
      }}
    >
      <Icon
        name={isMuted ? 'pause' : 'play'}
        size={14}
        color={iconColor}
      />
    </button>
  );
}
